import { Component } from '@angular/core';
import { CustomModalService, registeredIconIndex, userStatus } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-history-details',
  templateUrl: './history-details.component.html',
  styleUrls: ['./history-details.component.scss'],
})
export class HistoryDetailsComponent {
  statusList: any;
  emailStatus: any;
  negativeEmailStatus: any;
  userName: any;
  modalLabel = 'Request history details';
  userData: any;
  constructor(private modal: CustomModalService) {}

  ngOnInit(): void {
    this.statusList = this.modal?.modalService?.config?.initialState?.['statusList'];
    this.emailStatus = this.modal?.modalService?.config?.initialState?.['emailStatus'];
    this.negativeEmailStatus =
      this.modal?.modalService?.config?.initialState?.['negativeStatusList'];
    this.userName = this.modal?.modalService?.config?.initialState?.['userName'];
    this.userData = this.modal?.modalService?.config?.initialState?.['userData'];
    this.sortEmailStatus();
  }

  onClose() {
    this.modal.close();
  }

  private sortEmailStatus() {
    this.emailStatus.sort(
      (a: any, b: any) => new Date(a.SentOn).getTime() - new Date(b.SentOn).getTime()
    );
  }

  isStatusComplete(id: number): boolean {
    if (id == registeredIconIndex && this.userData.userStatus == userStatus.Trial) {
      return true;
    } else if (id == registeredIconIndex && this.userData.userStatus == userStatus.Purchased) {
      return true;
    } else {
      return this.emailStatus.some((status: any) => status.Type === id && status.Sent);
    }
  }

  getStatusDate(id: number): string | null {
    const emailStatus = this.emailStatus.find((status: any) => status.Type === id);
    if (
      (id == registeredIconIndex && this.userData.userStatus == userStatus.Trial) ||
      (id == registeredIconIndex && this.userData.userStatus == userStatus.Purchased)
    ) {
      return this.userData?.registeredOnFormatted;
    } else {
      return emailStatus?.SentOn || null;
    }
  }

  getStatusDetails(status: any, date: any): string {
    const formatDate = (date: any): string => {
      if (!date) return '';
      return date;
    };
    const formattedDate = formatDate(date);
    if (!formattedDate) return '';

    const organizationName = this.userData?.organizationNames?.includes(';')
      ? this.userData.organizationNames.split(';')
      : this.userData.organizationNames;
    switch (status?.id) {
      case 1:
        return `${this.userName} requested for a demo on ${formattedDate}`;
      case 2:
        return `An email was sent with demo credentials to ${this.userName} on ${formattedDate}`;
      case 3:
        return `${this.userName} watched the video on ${formattedDate}`;
      case 4:
        return `The follow-up email was sent to ${this.userName} on ${formattedDate}`;
      case 5:
        if (
          (this.userData.userStatus == userStatus.Trial ||
            this.userData.userStatus == userStatus.Purchased) &&
          this.userData?.organizationNames?.includes(';')
        ) {
          return `${this.userName} is associated with ${organizationName} organizations`;
        } else if (
          this.userData.userStatus == userStatus.Trial ||
          this.userData.userStatus == userStatus.Purchased
        ) {
          return `${this.userName} created  a new organization ${
            organizationName ? organizationName : ''
          } on ${formattedDate}`;
        } else {
          return '';
        }
      default:
        return '';
    }
  }

  getBadgeText(id: number): string {
    switch (id) {
      case 1:
        return 'Request #' + new Date().getFullYear() + '-001';
      case 2:
        return 'Email Delivered';
      case 3:
        return 'Video Complete';
      case 4:
        return 'Feedback Requested';
      case 5:
        return 'Registration Complete';
      default:
        return '';
    }
  }

  getIconForStatus(id: number): string {
    switch (id) {
      case 1:
        return 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v-2H5v2zm0-4h14V9H5v2z';
      case 2:
        return 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0-2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z';
      case 3:
        return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z';
      case 4:
        return 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z';
      case 5:
        return 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z';
      default:
        return '';
    }
  }
  getNegativeStatusName(id: number): string {
    const negativeStatus = this.negativeEmailStatus.find((item: any) => item.id === id);
    return negativeStatus ? negativeStatus.name : '';
  }
  getIconColor(iconId: number): string {
    if (this.emailStatus) {
      const emailStatus = this.emailStatus.find((item: any) => item.Type == iconId);
      if (
        (iconId == registeredIconIndex && this.userData.userStatus == userStatus.Trial) ||
        (iconId == registeredIconIndex && this.userData.userStatus == userStatus.Purchased)
      ) {
        return '#fff';
      } else if (emailStatus) {
        return '#fff';
      } else {
        return '#9747FF';
      }
    }
    return '#9747FF';
  }

  statusName(status: any) {
    if (status.id == registeredIconIndex && this.userData.userStatus == userStatus.Trial) {
      return 'User has registered for a free trial';
    } else if (
      status.id == registeredIconIndex &&
      this.userData.userStatus == userStatus.Purchased
    ) {
      return 'User has purchased a license';
    } else {
      return status.name;
    }
  }
}
